import Button from "@mui/material/Button";
import EditIcon from "assets/icons/EditIcon";
import { Dispatch, SetStateAction, useContext } from "react";
import useIsCreate from "hooks/useIsCreate";
import { LoadingButton } from "@mui/lab";
import DeleteIcon from "assets/icons/DeleteIcon";
import ButtonWithPermissions, { generateUnavailableText } from "components/buttons/ButtonWithPermissions";
import { CompanyContext } from "context/companyContext";
import { Stack, Tooltip } from "@mui/material";

type SaveEditButtonsProps = {
  isEdited: boolean;
  isEditable?: boolean;
  editingButtonDisable?: boolean;
  editingButtonTooltipText?: string;
  onSubmit: () => void;
  setIsEdited: Dispatch<SetStateAction<boolean>>;
  loading?: boolean;
  deleteText?: string;
  topAdditionalContent?: JSX.Element;
  bottomAdditionalContent?: JSX.Element;
  onDelete?: () => void;
};

const SaveEditButtons = ({
  isEdited,
  isEditable = true,
  editingButtonDisable = false,
  editingButtonTooltipText,
  onSubmit,
  setIsEdited,
  loading,
  deleteText,
  topAdditionalContent,
  bottomAdditionalContent,
  onDelete,
}: SaveEditButtonsProps) => {
  const isCreate = useIsCreate();
  const { isCreateAvailable, currentCompany } = useContext(CompanyContext);
  return isEdited ? (
    <>
      {isCreate ? (
        <ButtonWithPermissions
          buttonText='Сохранить'
          onClick={onSubmit}
          tooltipText={generateUnavailableText(isCreateAvailable, currentCompany, "создания")}
          loading={loading}
        />
      ) : (
        isEditable && (
          <LoadingButton
            loading={loading}
            variant='contained'
            onClick={onSubmit}
            fullWidth
            size='medium'>
            Сохранить
          </LoadingButton>
        )
      )}
      {!isCreate && (
        <Stack
          spacing={4}
          sx={{ mt: 1 }}>
          <Stack spacing={1}>
            <Button
              size='medium'
              variant='outlined'
              color='secondary'
              fullWidth
              onClick={() => setIsEdited(false)}>
              Отменить
            </Button>
            {topAdditionalContent}
          </Stack>
          {(onDelete || bottomAdditionalContent) && (
            <Stack spacing={1}>
              {bottomAdditionalContent}
              {onDelete && (
                <Button
                  size='medium'
                  sx={{
                    justifyContent: "space-between",
                    textAlign: "left",
                    "&:hover .MuiSvgIcon-root": {
                      color: "primary.main",
                    },
                  }}
                  endIcon={<DeleteIcon sx={{ width: 24, height: 24, color: "base.200" }} />}
                  variant='outlined'
                  color='secondary'
                  fullWidth
                  onClick={onDelete}>
                  {deleteText}
                </Button>
              )}
            </Stack>
          )}
        </Stack>
      )}
    </>
  ) : (
    <Tooltip title={editingButtonTooltipText}>
      {/* span для корректной работы Tooltip */}
      <span>
        <LoadingButton
          endIcon={<EditIcon />}
          onClick={() => setIsEdited(true)}
          variant='contained'
          disabled={editingButtonDisable}
          loading={loading}
          sx={{
            py: 1,
            px: 2,
            width: "max-content",
            "& .MuiButton-endIcon": { margin: 0 },
          }}
        />
      </span>
    </Tooltip>
  );
};

export default SaveEditButtons;
